// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<header class=\"brec-authentication__header\">\n  <img src=\""
    + alias3((lookupProperty(helpers,"staticImage")||(depth0 && lookupProperty(depth0,"staticImage"))||alias2).call(alias1,"logo-light",{"name":"staticImage","hash":{},"data":data,"loc":{"start":{"line":2,"column":12},"end":{"line":2,"column":40}}}))
    + "\" alt=\""
    + alias3((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||alias2).call(alias1,"hospital.name",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":47},"end":{"line":2,"column":71}}}))
    + "\" data-test-header-logo/>\n</header>\n<main inject=\"main\"></main>\n<footer inject=\"footer\"></footer>\n";
},"useData":true});
